import { calculateScreenSize } from '@components-shared/utils/calculateScreenSize';
import { SCREEN_SIZE } from 'global.enums';
import { throttle } from 'lodash-es';

type Subscription = (screenSize: keyof typeof SCREEN_SIZE) => void;

class ScreenSizeObserver {
  observedElement: HTMLElement;

  constructor(element?: HTMLElement) {
    const body = document.getElementsByTagName('body')[0];

    this.observedElement = element ?? body;
  }

  subscriptions: Subscription[] = [];

  currentScreenSize: keyof typeof SCREEN_SIZE | null = null;

  resizeObserver: ResizeObserver = new ResizeObserver(
    throttle(
      (entries) => {
        const elementWidth = entries[0].contentRect.width;
        const updatedScreenSize = calculateScreenSize(elementWidth);

        if (updatedScreenSize !== this.currentScreenSize) {
          this.currentScreenSize = updatedScreenSize;
          this.subscriptions.forEach((cb) => cb(updatedScreenSize));
        }
      },
      0,
      { leading: false, trailing: true },
    ),
  );

  initResizeObserver() {
    this.resizeObserver.observe(this.observedElement);
  }

  subscribe(callback: Subscription) {
    if (this.subscriptions.length === 0) {
      this.initResizeObserver();
    }

    this.subscriptions.push(callback);
  }

  unsubscribe(callback: Subscription) {
    this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
    if (this.subscriptions.length === 0) {
      this.resizeObserver.disconnect();
      this.currentScreenSize = null;
    }
  }
}

export const screenSizeObserver = new ScreenSizeObserver();
